import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Stripe.js is loaded once for the whole app. The publishable key is safe to
 * expose to the browser; it must be the SAME Stripe account the EMS app uses,
 * since both read the one organization's customer, cards, and invoices.
 *
 * With no key set, `isStripeConfigured` is false and the card form degrades to
 * a clearly-labelled "not configured" state instead of crashing — every other
 * billing surface (plans, invoices, subscription) keeps working.
 */
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined;

export const isStripeConfigured = Boolean(publishableKey);

export const stripePromise: Promise<Stripe | null> = publishableKey
  ? loadStripe(publishableKey)
  : Promise.resolve(null);
